import React, { useState } from 'react';

import { Container, Button, MensagemErro } from './styles';

import { Spinner } from '../../../StyledComponent';

import MessagePopUp from '../../../MessagePopup';

import { ButtonPrimary } from '../../../StyledComponent';

const ErrorMsg = ({ children }) => {
  return <p style={{ color: '#4d4d4d', fontSize: '12px' }}>{children}</p>;
};

const Buttons = ({
  setEditarSolicitacao,
  tema,
  dataAgendamento,
  origemSolicitacao,
  statusSolicitacao,
  editarSolicitacao,
  setShowCancelarSolicitacao,
  handleCancelEdit,
  subgrupo,
  salvarAlteracoes,
  setSalvarAlteracoes,
  handleSaveChanges,
  entendiConcordo,
  executeScroll,
  savingChanges,
}) => {
  const [showSucessEditSolicitacaoPopup, setShowSucessEditSolicitacaoPopup] =
    useState(false);

  let mensagemErroNaoPodeCancelar = '';
  let mensagemErroNaoPodeEditarSolicitacao = '';
  let desabilitaBotaoCancelar = false;

  if (dataAgendamento) {
    let actualDate = new Date();
    actualDate.setMinutes(new Date().getTimezoneOffset());
    let agendamentoDate = new Date(dataAgendamento);
    agendamentoDate.setMinutes(new Date(dataAgendamento).getTimezoneOffset());
    // se retornar true quer dizer que não pode cancelar o agendamento (menos que 24 horas)
    if (agendamentoDate.getTime() - actualDate.getTime() < 86400000) {
      desabilitaBotaoCancelar = true;
      mensagemErroNaoPodeCancelar = (
        <ErrorMsg>
          Não é possível realizar o cancelamento de agendamentos com menos de
          <span>
            <strong> 24 horas.</strong>
          </span>
        </ErrorMsg>
      );
      if (subgrupo === 'AT_INCORPORACAO')
        mensagemErroNaoPodeEditarSolicitacao = (
          <ErrorMsg>
            Não é possível editar solicitações com menos de
            <span>
              <strong> 24 horas.</strong>
            </span>
          </ErrorMsg>
        );
    }
  }

  if (origemSolicitacao !== 'Portal') {
    desabilitaBotaoCancelar = true;
    mensagemErroNaoPodeCancelar = (
      <ErrorMsg>
        Não é possível realizar o cancelamento de solicitações que não foram
        abertas pelo{' '}
        <span>
          <strong>Portal.</strong>
        </span>
      </ErrorMsg>
    );
  } else if (
    statusSolicitacao == 'Cancelado' ||
    statusSolicitacao == 'Fechado' ||
    statusSolicitacao == 'Concluído'
  ) {
    desabilitaBotaoCancelar = true;
    mensagemErroNaoPodeCancelar = (
      <ErrorMsg>
        Não é possível realizar o cancelamento de solicitações que não estão{' '}
        <span>
          <strong>Em Atendimento.</strong>
        </span>
      </ErrorMsg>
    );
    mensagemErroNaoPodeEditarSolicitacao = (
      <ErrorMsg>
        Não é possível editar solicitações que não estão{' '}
        <span>
          <strong>Em Atendimento.</strong>
        </span>
      </ErrorMsg>
    );
  }

  const handleCancel = () => {
    setShowCancelarSolicitacao((prevState) => !prevState);
  };

  const handleSalvarAlteracoes = async () => {
    await handleSaveChanges();
    setSalvarAlteracoes(false);
    setEditarSolicitacao(false);
    setShowSucessEditSolicitacaoPopup(true);
  };

  const handleEditarSolicitacao = () => {
    if (editarSolicitacao) handleCancelEdit();
    else {
      executeScroll();
      setEditarSolicitacao(true);
    }
  };

  return (
    <Container subgrupo={subgrupo}>
      {subgrupo === 'AT_INCORPORACAO' && (
        <>
          {mensagemErroNaoPodeEditarSolicitacao && (
            <MensagemErro>{mensagemErroNaoPodeEditarSolicitacao}</MensagemErro>
          )}

          {salvarAlteracoes && (
            <Button
              colorTheme={tema.primaryColor}
              onClick={() => handleSalvarAlteracoes()}
              editarSolicitacao={
                editarSolicitacao && entendiConcordo && !savingChanges
              }
              disabled={!entendiConcordo || savingChanges}
              savingChanges={savingChanges}
              id={'btnSalvarAlteracoes'}
            >
              {savingChanges && <Spinner />}
              {!savingChanges && (
                <>
                  <span>SALVAR ALTERAÇÕES</span>
                  <span>+</span>
                </>
              )}
            </Button>
          )}

          {!salvarAlteracoes && !mensagemErroNaoPodeEditarSolicitacao && (
            <Button
              colorTheme={tema?.primaryColor}
              onClick={handleEditarSolicitacao}
              editarSolicitacao={editarSolicitacao}
              id={'btnEditarSolicitacao'}
            >
              <span>EDITAR SOLICITAÇÃO</span>
              <span>+</span>
            </Button>
          )}

          {editarSolicitacao && (
            <Button
              colorTheme={'#be2f25'}
              onClick={() => handleCancelEdit()}
              editarSolicitacao={editarSolicitacao}
              disabled={savingChanges}
              id={'btnDescartarAlteracoes'}
            >
              <span>DESCARTAR ALTERAÇÕES</span>
              <span>-</span>
            </Button>
          )}
        </>
      )}

      {/* mensagem de erro quando não pode cancelar a solicitação */}
      {mensagemErroNaoPodeCancelar && (
        <MensagemErro>{mensagemErroNaoPodeCancelar}</MensagemErro>
      )}

      {!desabilitaBotaoCancelar && (
        <Button
          colorTheme={'#be2f25'}
          disabled={desabilitaBotaoCancelar || editarSolicitacao}
          onClick={() => handleCancel()}
          id={'btnCancelarSolicitacao'}
        >
          <span>CANCELAR SOLICITAÇÃO</span>
          <span>x</span>
        </Button>
      )}
      {showSucessEditSolicitacaoPopup && (
        <MessagePopUp
          title={'Alterações feitas com sucesso!'}
          message={'A correção no reparo foi realizada'}
        >
          <ButtonPrimary
            fullWidth
            tema={tema}
            onClick={() => setShowSucessEditSolicitacaoPopup(false)}
            id={'btnConfirmarEdicaoSolicitacao'}
          >
            Confirmar
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </Container>
  );
};

export default Buttons;
